module.exports = __webpack_public_path__ + "img/07-Van-Minibus.da28af28.svg";